import interestForm from "./interest-form";

const ELEMENT_SELECTOR = "[data-interest-form]";
const element = document.querySelector(ELEMENT_SELECTOR);

if (element) {
	interestForm(element);
}



// WEBPACK FOOTER //
// ./project/client/src/core/components/interest-form/index.js